import { classNames } from '@dimjs/utils';
import { hooks } from '@wove/react';
import { useRef, useState } from 'react';
import { usePropsValue } from '../hooks/use-props-value';
import { CommonPropsWithChildren } from '../utils';
import { Passcode } from './passcode';
import './styles/passcode-input.less';

export type PasscodeInputProps = CommonPropsWithChildren & {
  defaultValue?: string;
  onInputFinish: (value: string) => Promise<void>;
  gridsCount?: number;
  isPlain?: boolean;
};
export const PasscodeInput = (props: PasscodeInputProps) => {
  const nativeInputRef = useRef<HTMLInputElement>(null);
  const [focused, setFocused] = useState(false);
  const [isError, setIsError] = useState(false);
  const gridsCount = props.gridsCount || 6;

  const [value, setValue] = usePropsValue({ defaultValue: props.defaultValue || '' });

  const onPasscodeFocus = hooks.useCallbackRef(() => {
    nativeInputRef.current?.focus();
    setFocused(true);
  });

  const onPasscodeBlur = hooks.useCallbackRef(() => {
    nativeInputRef.current?.blur();
    setFocused(false);
  });

  const onInputChange = hooks.useCallbackRef((event) => {
    const value = event.target.value as string;
    setValue(value);
    setIsError(false);
    if (value.length === gridsCount) {
      props.onInputFinish(value).catch(() => {
        setIsError(true);
      });
    }
  });

  return (
    <div className={classNames('v-passcode-input', props.className)} style={props.style}>
      <Passcode
        isError={isError}
        isPlain={props.isPlain}
        isFocused={focused}
        value={value}
        onFocus={onPasscodeFocus}
      >
        <input
          ref={nativeInputRef}
          maxLength={gridsCount}
          onChange={onInputChange}
          value={value}
          onBlur={onPasscodeBlur}
        />
      </Passcode>
    </div>
  );
};
